<template>
    <div class="form-build">
        <div style="display:none">{{formDataBind}}</div>
      <el-form :ref="formName" :model="formDataBind" :rules="formRules" :label-width="labelWidth" :inline="inline" :class="{border: border}">
        <el-row>
          <!-- 不分组 -->
          <template v-for="(column,idx) in formColumns">
            <el-col :span="typeof column.span == 'function' ? column.span(formDataBind, formDataBind[column.field]) :  (column.span||12)"  :key="idx" v-show="checkCondition(column.conditions, formDataBind, formDataBind[column.field])">
              <el-form-item  :label="column.label ? column.label +'：': ''" :prop="column.field">
                <template v-if="column.component">
                  <component
                    :is="typeof column.component == 'function' ? column.component(formDataBind, formDataBind[column.field]) : column.component"
                    v-model="formDataBind[column.field]"
                    :options="column.options"
                    :type="column.type"
                    :placeholder="column.placeholder"
                    :value-format="column.valueFormat"
                    :filterable="column.filterable"
                    :picker-options="column.pickerOptions"
                    :maxlength="column.maxLength"
                    :minlength="column.minLength"
                    :readonly="column.readonly"
                    :disabled="column.disabled"
                    :rows="column.rows"
                    v-bind="column.props||{}"
                  >
                    <el-option
                      v-for="(item, idx2) in column.options"
                      :key="item.key||item.value"
                      :label="item.label"
                      :value="item.value"
                      v-if="column.component == 'el-select'"
                    />
                    <template slot="append" v-if="column.unit">{{column.unit}}</template>
                    <template :slot="item.slot" v-for="item in column.slots">
                      <template v-if="item.component">
                        <component :is="item.component" v-model="formDataBind[item.field]" v-bind="item.props||{}">
                          <el-option
                            v-for="option in (item.props||{}).options"
                            :key="option.key||option.value"
                            :label="option.label"
                            :value="option.value"
                            v-if="item.component == 'el-select'"
                          />
                        </component>
                      </template>
                      <template v-else>{{item.template}}</template>
                    </template>
                  </component>
                </template>
                <template v-else>
                  <template>
                    {{formDataBind|filterHandler(column.formatter||null, formDataBind[column.field])}}
                  </template>
                  {{column.unit}}
                </template>
              </el-form-item>
            </el-col>
          </template>
          <!-- 分组 -->
          <panel :title="group.label||''" :border="group.border" v-for="(group, groupIdx) in formColumnsGroup" :key="groupIdx">
            <el-col :span="typeof column.span == 'function' ? column.span(formDataBind, formDataBind[column.field]) :  (column.span||12)" v-for="(column,idx) in group.columns" :key="idx" v-show="checkCondition(column.conditions, formDataBind, formDataBind[column.field])">
              <el-form-item  :label="column.label ? column.label +'：': ''" :prop="column.field">
                <template v-if="column.component">
                  <component
                    :is="column.component"
                    v-model="formDataBind[column.field]"
                    :options="column.options"
                    :type="column.type"
                    :placeholder="column.placeholder"
                    :value-format="column.valueFormat"
                    :filterable="column.filterable"
                    :picker-options="column.pickerOptions"
                    :maxlength="column.maxLength"
                    :minlength="column.minLength"
                    :readonly="column.readonly"
                    :disabled="column.disabled"
                    :style="column.style"
                    :rows="column.rows"
                    v-show="!column.hide"
                    v-bind="column.props||{}"
                  >
                    <el-option
                      v-for="(item, idx2) in column.options"
                      :key="item.key||item.value"
                      :label="item.label"
                      :value="item.value"
                      v-if="column.component == 'el-select'"
                    />
                    <template slot="append" v-if="column.unit">{{column.unit}}</template>
                    <template :slot="item.slot" v-for="item in column.slots">{{item.template}}</template>
                  </component>
                </template>
                <template v-else>
                  <template>
                    {{formDataBind|filterHandler(column.formatter||null, formDataBind[column.field])}}
                  </template>
                  {{column.unit}}
                </template>
              </el-form-item>
            </el-col>
          </panel>
          <el-col :span="24" v-if="formButtons.length>0">
            <el-form-item>
              <el-button
                :type="button.type"
                :class="button.class"
                :size = "button.size"
                @click="button.clickHandler($refs[formName])"
                v-for="(button,idx3) in formButtons"
                :key="idx3"
              >
                {{button.label}}
              </el-button>
            </el-form-item>
          </el-col>
          <slot></slot>
        </el-row>
      </el-form>
    </div>
</template>

<script>
  export default {
    name: "FormBuildComponent",
    data() {
      return {

      }
    },
    filters: {
      filterHandler: function (r,f,v) {
        if(r ) {
          if(typeof f == 'function') {
            return f.apply(this,[r,v])
          }
          else {
            return typeof v == 'string' ?  v||'' : v
          }
        }
      }
    },
    props: {
      label: String,
      labelWidth: {
        type: String,
        default: '150px'
      },
      border: {
        type: Boolean,
        default: false
      },
      inline: {
        type: Boolean,
        default: false
      },
      formColumns: {
        type: Array,
        default:()=>{
          return []
        }
      },
      formColumnsGroup: {
        type: Array,
        default:()=>{
          return []
        }
      },
      formName: {
        type: String,
        default: 'FormName'
      },
      formData:  {
        type: Object,
        default:()=>{
          return {}
        }
      },
      formRules: {
        type: Object,
        default:()=>{
          return {}
        }
      },
      formButtons: {
        type: Array,
        default:()=>{
          return []
        }
      },
    },
    computed: {
      formDataBind: {
        get() {
          return this.formData
        },
        set(newVal) {
          this.$emit('update:formData', newVal)
        }
      }
    },
    methods: {
      checkCondition: function (conditions, r, v) {
        if(typeof conditions == 'undefined') {
          return true
        }
        else if(typeof conditions == 'boolean') {
          return conditions
        }
        else if(typeof conditions == 'function') {
          return conditions.apply(null, [r, v])
        }
        else {
          return true
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FormBuild.vue